import React, { FC } from 'react';

import clsx from 'clsx';
import { NumericFormat } from 'react-number-format';

import { formatAmountWithCurrency } from '@utils/currency';
import { KopecksIso } from '@utils/isomorph';

import styles from './CategoryPriceRangeInput.module.scss';

export type CategoryPriceRangeInputVariant = 'primary' | 'secondary';

export type CategoryPriceRangeInputProps = {
    value: FeipApi.Kopecks | undefined;
    prefix: string;
    placeholderValue: FeipApi.Kopecks | null;
    variant?: CategoryPriceRangeInputVariant;
    className?: string;
    onChange?(value: number | undefined): void;
    onBlur?(): void;
};

const variantToClassMap: Record<CategoryPriceRangeInputVariant, string> = {
    primary: styles.isVariantPrimary,
    secondary: styles.isVariantSecondary,
};

export const CategoryPriceRangeInput: FC<
    CategoryPriceRangeInputProps & { 'data-testid'?: string }
> = (props) => {
    const {
        value,
        prefix,
        placeholderValue,
        onChange,
        onBlur,
        className,
        variant = 'primary',
        'data-testid': dataTestId,
    } = props;

    return (
        // NumericFormat renders an input - a control,
        // but it is not recognized by this disabled lint.
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label className={clsx(styles.root, variantToClassMap[variant], className)}>
            <span className={styles.prefix}>{prefix}</span>
            <NumericFormat
                type="text"
                pattern="\d*" // Opens the numeric keypad on mobile devices
                value={value !== undefined ? KopecksIso.get(value) : ''}
                suffix=" ₽"
                thousandSeparator=" "
                placeholder={
                    placeholderValue !== null
                        ? formatAmountWithCurrency(placeholderValue)
                        : undefined
                }
                className={styles.input}
                size={1}
                decimalScale={2}
                allowNegative={false}
                valueIsNumericString
                onValueChange={(values) => {
                    if (onChange !== undefined) onChange(values.floatValue);
                }}
                onBlur={onBlur}
                data-testid={dataTestId}
            />
        </label>
    );
};
